import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { hidePopup } from '../../../../common/redux/popup-manager/popup-manager.actions';
import { isLaserEngravedEmbelishmentMethodPopupShownSelector, popupParamsSelector } from '../../../../common/redux/popup-manager/popup-manager.selector';
import { changeEmbellishmentMethodWithProductionTimeValidation } from '../../../redux/product/product.actions';
import { LaserEngravedEmbelishmentMethodPopupComponent as Component } from './laser-engraved-embelishment-method-popup';
export * from './laser-engraved-embelishment-method-popup';
const methodIdSelector = createSelector(popupParamsSelector, params => params.methodId);
const selectors = createStructuredSelector({
  open: isLaserEngravedEmbelishmentMethodPopupShownSelector,
  methodId: methodIdSelector
});
const actions = dispatch => ({
  onClose: methodId => {
    dispatch(hidePopup());
    if (methodId) {
      dispatch(changeEmbellishmentMethodWithProductionTimeValidation(methodId));
    }
  }
});
const connector = connect(selectors, actions);
export const LaserEngravedEmbelishmentMethodPopup = connector(Component);